import {take, call, put, select} from "redux-saga/effects";

import {AuthSelectors} from "@atg-shared/auth";

import {
    type GetMemberCustomizationResponseAction,
    MemberCustomizationActions,
} from "./memberCustomizationActions";
import * as CustomizationAPI from "./memberCustomizationApi";
import {GET_MEMBER_CUSTOMIZATION_RESPONSE} from "./memberCustomizationConstants";
import * as MemberCustomizationSelectors from "./memberCustomizationSelectors";

import type {SetMemberTeamsPayload} from "@atg-tillsammans/team-member-data-access";
import type {PayloadAction} from "@reduxjs/toolkit";
import type {SagaIterator} from "redux-saga";

export function* fetchMemberCustomization(): SagaIterator {
    try {
        const {ok, data} = yield call(CustomizationAPI.getMemberCustomization);
        if (ok) {
            yield put(MemberCustomizationActions.fetchMemberCustomizationSuccess(data));
        } else {
            yield put(MemberCustomizationActions.fetchMemberCustomizationError());
        }
    } catch (e: unknown) {
        yield put(MemberCustomizationActions.fetchMemberCustomizationError());
    }
}

export function* initMemberCustomization(): SagaIterator {
    yield put(MemberCustomizationActions.fetchMemberCustomization());

    const {error, payload}: GetMemberCustomizationResponseAction = yield take([
        GET_MEMBER_CUSTOMIZATION_RESPONSE,
    ]);

    if (!error && payload.data?.length === 0) {
        try {
            const {flags} = yield select(
                MemberCustomizationSelectors.getMemberCustomization,
            );

            const {ok, data} = yield call(CustomizationAPI.createMemberCustomization, {
                flags,
            });

            if (ok) {
                yield put(MemberCustomizationActions.addMemberCustomizationSuccess(data));
            }
        } catch (e: unknown) {
            yield put(MemberCustomizationActions.addMemberCustomizationError());
        }
    }
}

export function* cleanupMemberCustomization(): SagaIterator {
    const isLoggedIn = yield select(AuthSelectors.isLoggedIn);

    if (!isLoggedIn) return;

    const memberCustomization = yield select(
        MemberCustomizationSelectors.getMemberCustomization,
    );

    if (memberCustomization.id) {
        const {ok} = yield call(
            CustomizationAPI.updateMemberCustomization,
            memberCustomization,
        );

        if (ok) {
            yield put(MemberCustomizationActions.clearMemberCustomization());
        }
    }
}

export function* updateStartPageFlags({
    payload,
}: PayloadAction<SetMemberTeamsPayload>): SagaIterator {
    const isLoggedIn = yield select(AuthSelectors.isLoggedIn);

    if (!isLoggedIn) return;

    yield put(
        MemberCustomizationActions.setStartPageHeroFlag(
            (payload.data.myTeams?.length ?? 0) <= 0,
        ),
    );
}
